import hljs from 'highlight.js/lib/core';
import xml from 'highlight.js/lib/languages/xml';

hljs.registerLanguage('xml', xml);

hljs.highlightBlock = function () {
  let blocks = document.querySelectorAll('pre code');
  for (let i = 0; i < blocks.length; i++) {
      hljs.highlightBlock(blocks[i]);
  }
};

export default hljs;
